import * as ACTION_TYPES from './constants';

import { Setting } from '../../../Api';

import { Toast } from '../../Common';
import { SettingFinanceReducer } from './index';
import { fromJS } from 'immutable';

const Api = Setting.Finance;

const reducer = 'SettingFinanceReducer';

export default class SettingFinanceActions {
    static loading_index = toggle => ({
        type: ACTION_TYPES.SETTING_FINANCE_LOADING_INDEX,
        toggle,
    });

    static loading_show = toggle => ({
        type: ACTION_TYPES.SETTING_FINANCE_LOADING_SHOW,
        toggle,
    });

    static search =
        (search = {}) =>
        async (dispatch, getState) => {
            dispatch({ type: ACTION_TYPES.SETTING_FINANCE_SEARCH, search });
        };

    static requests = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_index(true));
            const query = getState()[reducer].get('search');
            const res = await Api.index(query);
            if (res instanceof Error) throw res;
            dispatch(this.index(res));
        } catch (error) {
            dispatch(this.loading_index(false));
            console.error(error);
        } finally {
        }
    };

    static index = (statements = []) => ({
        type: ACTION_TYPES.SETTING_FINANCE_INDEX,
        statements,
    });

    static request = params => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const res = await Api.show(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static create = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show());
            const body = getState()[reducer].get('statement');
            const res = await Api.create(body);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
            Toast.success('记录已保存');
            dispatch(this.requests());
            dispatch(this.options());
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static destroy = () => async (dispatch, getState) => {
        try {
            const params = getState()[reducer].getIn(['statement', 'id']);
            dispatch(this.loading_show());
            const res = await Api.destroy(params);
            if (res instanceof Error) throw res;
            dispatch(this.show(res));
            Toast.success('记录已删除');
            dispatch(this.requests());
        } catch (error) {
            dispatch(this.loading_show());
            console.error(error);
        } finally {
        }
    };

    static show = (statement = {}) => ({
        type: ACTION_TYPES.SETTING_FINANCE_SHOW,
        statement,
    });

    static reset = () => ({
        type: ACTION_TYPES.SETTING_FINANCE_RESET,
    });

    static column = (columns = []) => ({
        type: ACTION_TYPES.SETTING_FINANCE_COLUMN,
        columns,
    });

    static collect_request = query => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show(true));
            const collect = getState().SettingFinanceReducer.get('collect');
            const res = await Api.collect_request(query);
            if (res instanceof Error) throw res;
            dispatch(this.collect(collect.set('remains', fromJS(res))));
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static collect_create = () => async (dispatch, getState) => {
        try {
            dispatch(this.loading_show(true));
            const collect = getState().SettingFinanceReducer.get('collect');
            const res = await Api.collect_create(collect);
            if (res instanceof Error) throw res;
            dispatch(this.requests());
            dispatch(this.collect());
        } catch (error) {
            dispatch(this.loading_show(false));
            console.error(error);
        } finally {
        }
    };

    static collect = (collect = {}) => ({
        type: ACTION_TYPES.SETTING_FINANCE_COLLECT,
        collect,
    });
}
